import { Component } from '@theme/component';
/** @extends {Component<{menu: HTMLDetailsElement}>} */
class NSBHeader extends Component {
  #controller;
  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    this.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.closest('nav a')) this.#close(false);
    }, options);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.#close(true);
    }, options);
    document.addEventListener('click', (event) => {
      if (event.target instanceof Node && !this.contains(event.target)) this.#close(false);
    }, options);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }
  #close(restoreFocus) {
    const openMenus = Array.from(this.querySelectorAll('details[open]'));
    const focusMenu = this.refs.menu?.open ? this.refs.menu : openMenus[0];
    for (const menu of openMenus) menu.open = false;
    if (restoreFocus) focusMenu?.querySelector('summary')?.focus();
  }
}
if (!customElements.get('nsb-header')) customElements.define('nsb-header', NSBHeader);
